/**
 * Short relative time for dense status lines: "now", "1m ago", "2h ago",
 * "3d ago". The exact instant stays in the element's title and datetime, so
 * brevity loses nothing (UX_ARCHITECTURE.md, UI copy and information density).
 */
export function agoShort(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return 'never';
  const ms = now - Date.parse(iso);
  if (!Number.isFinite(ms)) return 'never';
  const minutes = Math.floor(ms / 60000);
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

/** "2 hours ago", for the accessible name of an item that shows "2h ago". */
export function agoSpoken(iso: string | null | undefined, now: number = Date.now()): string {
  if (!iso) return 'never';
  const ms = now - Date.parse(iso);
  if (!Number.isFinite(ms)) return 'never';
  const minutes = Math.floor(ms / 60000);
  const unit = (count: number, word: string) => `${count} ${word}${count === 1 ? '' : 's'} ago`;
  if (minutes < 1) return 'just now';
  if (minutes < 60) return unit(minutes, 'minute');
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return unit(hours, 'hour');
  return unit(Math.floor(hours / 24), 'day');
}

